import { httpTransport } from '../transport';
import { RequestOptions } from '../transport/types';

/**
 * Enterprise-grade API client backward-compatibility adapter.
 * Delegates all operations to the deepened Tier 1 HttpTransport module.
 */
export class APIClient {
  static initialize(_baseURL?: string) {
    // HttpTransport handles initialization internally via FetchNetworkAdapter.
  }

  static getInstance() {
    return {
      get: async <T = any>(url: string, options?: any) => {
        const data = await httpTransport.get<any>(url, options);
        return { data: { success: true, data } };
      },
      post: async <T = any>(url: string, data?: any, options?: any) => {
        const res = await httpTransport.post<any>(url, data, options);
        return { data: { success: true, data: res } };
      },
      put: async <T = any>(url: string, data?: any, options?: any) => {
        const res = await httpTransport.put<any>(url, data, options);
        return { data: { success: true, data: res } };
      },
      patch: async <T = any>(url: string, data?: any, options?: any) => {
        const res = await httpTransport.patch<any>(url, data, options);
        return { data: { success: true, data: res } };
      },
      delete: async <T = any>(url: string, options?: any) => {
        const res = await httpTransport.delete<any>(url, options);
        return { data: { success: true, data: res } };
      },
    };
  }

  static async get<T>(url: string, options?: RequestOptions): Promise<T & { data?: any }> {
    const result = await httpTransport.get<any>(url, options);
    if (result && typeof result === 'object' && !('data' in result)) {
      Object.defineProperty(result, 'data', {
        value: result,
        writable: true,
        configurable: true,
      });
    }
    return result;
  }

  static async post<T>(url: string, data?: any, options?: RequestOptions): Promise<T & { data?: any }> {
    const result = await httpTransport.post<any>(url, data, options);
    if (result && typeof result === 'object' && !('data' in result)) {
      Object.defineProperty(result, 'data', {
        value: result,
        writable: true,
        configurable: true,
      });
    }
    return result;
  }

  static async put<T>(url: string, data?: any, options?: RequestOptions): Promise<T & { data?: any }> {
    const result = await httpTransport.put<any>(url, data, options);
    if (result && typeof result === 'object' && !('data' in result)) {
      Object.defineProperty(result, 'data', {
        value: result,
        writable: true,
        configurable: true,
      });
    }
    return result;
  }

  static async patch<T>(url: string, data?: any, options?: RequestOptions): Promise<T & { data?: any }> {
    const result = await httpTransport.patch<any>(url, data, options);
    if (result && typeof result === 'object' && !('data' in result)) {
      Object.defineProperty(result, 'data', {
        value: result,
        writable: true,
        configurable: true,
      });
    }
    return result;
  }

  static async delete<T>(url: string, options?: RequestOptions): Promise<T & { data?: any }> {
    const result = await httpTransport.delete<any>(url, options);
    return result;
  }

  static clearCache(_pattern?: string) {
    // Deprecated: TanStack React Query owns cache invalidation.
  }
}

export const apiClient = APIClient;
export default APIClient;
